export function getMobileSectionScrollContainer() {
  return document.getElementById("profile-section-mobile") as HTMLDivElement;
}
